/**
 * The platform vocabulary, alone in its own module.
 *
 * WHY IT IS NOT IN `mobile-deployment.ts` ANY MORE. That module imports
 * `MobileAppReadinessSchema`, and readiness now carries the push-channel
 * snapshot (SCH-1512 U6), and the snapshot is keyed by platform — which closed
 * a cycle: mobile-deployment → mobile-app-readiness → mobile-app-push-channel →
 * mobile-deployment. Zod builds its schemas at module-evaluation time, so a
 * cycle here is not a lint opinion: whichever module the bundler enters first
 * reads `undefined` off a half-initialised sibling and the package throws on
 * import.
 *
 * A leaf module with no imports of its own cannot participate in a cycle, which
 * is why this one stays that way. `mobile-deployment` re-exports both names, so
 * every existing importer keeps its path.
 */

import { z } from 'zod'

export const PlatformSchema = z.enum(['IOS', 'ANDROID'])
export type Platform = z.infer<typeof PlatformSchema>
